/* Shiprocket product-page BUY NOW skips the Shopify cart, so the free gift the cart drawer adds
   (window.WL_GIFT, same ₹ threshold on the non-gift selling price) never reached that checkout and
   Shiprocket's Buy X Get Y offer had nothing to discount. When the chosen variant × quantity qualifies,
   start Shiprocket's product checkout (its public direct-checkout entry, same payload builder as its own
   BUY NOW) with the product AND the gift line; otherwise hand the click
   back to Shiprocket's own handler untouched. */
(function () {
  'use strict';
  var NAME = 'shiprocketCheckoutBuyProductHandler';

  function giftCfg() {
    var g = window.WL_GIFT;
    return g && g.vid && Number(g.min) > 0 ? g : null;
  }

  function money(paise) { return parseFloat((Number(paise) / 100).toFixed(2)); }

  function productUrl(form) {
    var u = '';
    try { u = new FormData(form).get('productUrl') || ''; } catch (_) {}
    if (!u || u === '/') u = location.pathname.indexOf('/products/') > -1 ? location.pathname : '';
    return String(u).split(/[?#]/)[0];
  }

  function wrap(orig, page) {
    var wrapped = function (e) {
      var btn = e && e.currentTarget;
      try { if (e && e.stopPropagation) e.stopPropagation(); } catch (_) {}
      var ev = { currentTarget: btn, target: btn, stopPropagation: function () {}, preventDefault: function () {} };
      function fallback() { return orig.call(window, ev); }

      var g = giftCfg(), form = btn && btn.closest && btn.closest('form');
      if (!g || !form || String(form.getAttribute('action') || '').indexOf('/cart/add') < 0) return fallback();
      var fd = new FormData(form), vid = String(fd.get('id') || ''), qty = parseInt(fd.get('quantity'), 10);
      if (!(qty > 0)) qty = 1;
      var url = productUrl(form);
      if (!vid || vid === String(g.vid) || !url) return fallback();
      var note = fd.get('attributes[gift-message-note]');

      fetch(url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
          if (!p.available || !v || !v.available || v.price * qty < Number(g.min)) return fallback();
          var attrs = note ? { _giftWrap: 'yes', gift_note: note } : {};
          page({
            type: 'product',
            products: [
              {
                productId: p.id, title: v.name || p.title, variantId: v.id, variantTitle: v.public_title ? v.title : '',
                price: money(v.price), quantity: qty,
                image: (v.featured_image && v.featured_image.src) || (p.media && p.media[0] && p.media[0].src) || p.featured_image,
                item_meta_data: { properties: v.properties }, customAttributes: attrs, vendor: p.vendor, product_type: p.type
              },
              {
                productId: g.pid, title: g.title, variantId: Number(g.vid), variantTitle: '',
                price: money(g.price), quantity: 1, image: g.img, customAttributes: {}
              }
            ]
          });
        })
        .catch(fallback);
    };
    wrapped.__wlGift = true;
    return wrapped;
  }

  function install() {
    var orig = window[NAME], page = window.shiprocketCheckoutDirectHandler;
    if (typeof orig !== 'function' || typeof page !== 'function') return false;
    if (!orig.__wlGift) window[NAME] = wrap(orig, page);
    return true;
  }

  if (install()) return;
  var tries = 0, timer = setInterval(function () { if (install() || ++tries > 60) clearInterval(timer); }, 250);
})();
